<div
  class="sticky top-0 left-0 w-full border-b z-50 !bg-[var(--mat-bottom-sheet-container-background-color)]"
>
  <div class="w-full flex justify-between p-2">
    <div></div>
    <div class="font-bold">{{ title }}</div>
    <div></div>
  </div>
</div>
